import { styled } from '@mui/material';

export const FlexColumn = styled('div')(() => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
}));
export const FlexRow = styled('div')(() => ({
    flex: 1,
    display: 'flex',
}));
